'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  communicationTypeId: null,
  consented: false,
  required: false
}, 'LegalCommunicationConsent');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/models/LegalCommunicationConsent.js
// module id = 535
// module chunks = 0